import useUserData from 'hooks/useUserData';
import React, { useContext, useEffect, useState } from 'react';
import { get, set } from './GratitudesStorage';

export interface GratitudesContextProps {
  loaded: boolean;
  lastVisitedPage: number;
  setVisited: () => void;
}

const defaultLastVisited = new Date();
defaultLastVisited.setMonth(defaultLastVisited.getMonth() - 1);

const defaultContext: GratitudesContextProps = {
  loaded: false,
  lastVisitedPage: 0,
  setVisited: () => {
    ///asdasdasdasd
  },
};

const Context = React.createContext<GratitudesContextProps>(defaultContext);

const GratitudesContext = (props: React.PropsWithChildren<{}>) => {
  const { lastVisited } = get();
  const [loaded, setLoaded] = useState(false);
  const [lastVisitedPage, setLastVisitedPage] = useState(lastVisited || defaultLastVisited.getTime());

  const setVisited = () => {
    const time = Date.now();
    setLastVisitedPage(time);
    set({ lastVisited: time });
  };

  return (
    <Context.Provider
      value={{
        loaded,
        lastVisitedPage,
        setVisited,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export const useGratitudesContext = () => useContext(Context);

export default GratitudesContext;
